module.exports = __webpack_public_path__ + "static/media/services-1.8ebb6117.jpg";